<template>
  <Section>
    <Container>

      <FadeIn
      :class="[
        content.type === 'highlighted' ? 'rounded-[20px] md:rounded-[35px] bg-[#e2e4e9] border-2 border-[#d0d4df] px-4 md:px-8 py-6 md:py-12' : '',
        content.type === 'boxes' ? '' : ''
      ]">

        <div class="mx-auto max-w-2xl lg:text-center" v-if="content.title">
          <div class="mb-2 md:mb-4" v-if="content.pretitle">
            <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
              {{ content.pretitle }}
            </span>
          </div>
          <h2 class="text-section-title">{{ content.title }}</h2>
          <div
          v-if="content.subtitle"
          class="text-subtitle" 
          v-interpolation 
          v-html="content.subtitle"
          ></div>
        </div>

        <div 
        v-if="content.items"
        :class="[
          `mt-2 md:mt-16 mx-auto grid grid-cols-1`,
          content.items.length === 2 ? `max-w-[920px] gap-4 md:gap-8 xl:gap-12 md:grid-cols-2` : '',
          content.items.length === 3 ? `max-w-[1080px] gap-4 md:gap-8 xl:gap-12 md:grid-cols-3` : '',
          content.items.length === 4 ? `max-w-[920px] gap-4 md:gap-8 xl:gap-12 md:grid-cols-2 grid grid-cols-1` : '',
          content.items.length > 4 ? `max-w-[1080px] gap-x-4 md:gap-x-8 xl:gap-x-12 gap-y-4 md:gap-y-12 xl:gap-y-16 md:grid-cols-3` : '',
        ]"
        >
          <div 
          v-for="item in content.items"
          class="col-span-1 mt-4 md:mt-0"
          :class="[
            content.type === 'boxes' ? 'bg-[#e8e5de] border-2 border-[#d5d0c5] rounded-[20px] p-4 md:p-8' : ''
          ]"
          >
            <div class="rounded-lg p-0">
              <div 
              v-if="item.usp_id.type === 'icon'"
              class="mb-2 md:mb-4"
              >
                <div
                class="inline-block"
                :class="[
                  item.usp_id.icon_background ? 'rounded aspect-square inline-flex items-center' : '',
                  item.usp_id.icon_background && content.type == 'default' ? 'bg-[#e8e5de] p-2' : '',
                  item.usp_id.icon_background && content.type === 'highlighted' ? 'bg-[#5a6ded] text-white p-2' : '',
                  item.usp_id.icon_background && content.type === 'boxes' ? '' : ''
                ]">
                  <Icon
                  :name="item.usp_id.icon_name"
                  class="h-10 w-10 text-primary-500 mx-auto"
                  />
                </div>
              </div>
              <img v-else-if="item.usp_id.type === 'image'" 
              loading="lazy"
              :src="useCdn(item.usp_id.image.id, item.usp_id.image.filename_download)" 
              :alt="item.usp_id.image.description" 
              :width="item.usp_id.image.width"
              :height="item.usp_id.image.height"
              class="h-16 w-auto mb-2 md:mb-4"
              />
              <h3 class="font-bold tracking-tight text-gray-900 text-xl mb-4">{{ item.usp_id.title }}</h3>
              <p class="text-base text-gray-900">{{ item.usp_id.subtitle }}</p>
              <div v-if="item.usp_id.link" class="mt-4">
                <NuxtLink
                :to="$localePath(getLinkUrl(item.usp_id.link))"
                :target="item.usp_id.link.includes('http') && !item.usp_id.link.includes('elker.com') ? '_blank' : undefined"
                class="font-bold underline"
                >
                  {{ item.usp_id.link_text || `Learn more about ${item.usp_id.title}` }}
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>

      </FadeIn>

    </Container>

  </Section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  sectionIndex: {
    type: Number
  }
})

const getLinkUrl = link => {
  if (link.includes('elker.com')) {
    return link.split('elker.com')[1]
  }
  return link
}
</script>